import { ReactNode } from "react";

/**
 * Renders the two inline tags the page's i18n strings may carry: `<b>...</b>` and `<kbd>...</kbd>` (a key
 * label such as "Install plugin"). Parsed into React elements, never injected as HTML. Anything else,
 * including a stray `<`, stays literal text.
 */
export function rich(text: string): ReactNode[] {
	return text.split(/(<b>.*?<\/b>|<kbd>.*?<\/kbd>)/g).map((part, i) => {
		const bold = part.match(/^<b>(.*)<\/b>$/);
		if (bold) return <b key={i}>{bold[1]}</b>;
		const kbd = part.match(/^<kbd>(.*)<\/kbd>$/);
		if (kbd)
			return (
				<span key={i} className="kbd">
					{kbd[1]}
				</span>
			);
		return part;
	});
}
